import React from 'react';
import DessertsMenu from './DessertsMenu';
import DrinksMenu from './DrinksMenu';
import FastFoodsMenu from './FastFoodsMenu';
import MainDishesMenu from './MainDishesMenu';
import StartersMenu from './StartersMenu';

const Menu = () => {

    return (
        <div className='container bg-white py-20 w-full mx-auto'>
            <StartersMenu />
            <MainDishesMenu />
            <FastFoodsMenu />
            <DrinksMenu />
            <DessertsMenu />
        </div>
    );
};

export default Menu;